module.exports = __webpack_public_path__ + "04352885217bf43bea93eb6c6685a7c1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/kff-cds.svg?e1re96
// module id = 785
// module chunks = 0